
import HeaderPage from "../HeaderPage";
import Sidebar from "../Sidebar";
import MareIA from "./components/MareIA";


const Mare = () => {
  return (
    <div className="flex-dashboard">
      <Sidebar elementoAtivo="mareia" />
      <main>
        <HeaderPage nomeOpcao="Mare IA" />
        <div className="main-content">
         <MareIA />
        </div>
      </main>
    </div>
  );
};

export default Mare;
